<template>
    <div class="header" >
        <div>

            <h2>Juego Adivinanza Rick & Morty</h2>
            
        </div>
    </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
      font-family: 'Krona One', sans-serif;
  height:5em;
    background: rgb(154, 221, 212);
  background: linear-gradient(
    90deg,
    rgb(154, 221, 212, 1) 0%,
        rgba(171, 214, 227, 1) 50%,
    rgba(171, 214, 227, 1) 100%
  );
}
</style>